var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright-container"},[_c('p',[_vm._v("Copyright ©多彩网 2019~"+_vm._s(_vm.currentYear)+" All Right Reserved.")])])}
var staticRenderFns = []

export { render, staticRenderFns }